document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('header, .header, #shopify-section-header, .shopify-section-header-sticky');
  if (!header) return;
  window.addEventListener('scroll', function () {
    if (window.scrollY > 60) { header.classList.add('hm-header-solid'); }
    else { header.classList.remove('hm-header-solid'); }
  }, { passive: true });
});
